import axios from 'axios'
import axiosDummy from './axiosDummy'

const axiosInstance = axios.create({
    withCredentials: true,
    baseURL: '/api',
});

axiosInstance.defaults.headers.post['Content-Type'] = 'application/json'

if (process.env.NODE_ENV === 'development') {
    axiosInstance.get = axiosDummy.get;
    axiosInstance.post = axiosDummy.post;
    axiosInstance.put = axiosDummy.put;
    axiosInstance.delete = axiosDummy.remove;
}

export default axiosInstance;
